import { apiClient } from './apiClient';
import type { AdCampaignLocationTarget } from '@/types/ads';

export interface AlertMessage {
  id: string;
  alert: string;
  targetMode?: AlertTargetMode;
  targetUserIds?: number[];
  locationTargets?: AdCampaignLocationTarget[];
  createdDate?: string;
  updatedDate?: string;
  active?: boolean;
}

export type AlertTargetMode = 'ALL' | 'USERS' | 'LOCATION';

export interface UpsertAlertMessageRequest {
  alert: string;
  targetMode: AlertTargetMode;
  targetUserIds?: number[];
  locationTargets?: AdCampaignLocationTarget[];
}

const ALERT_MESSAGES_ENDPOINT = '/settings/alerts';

export const alertMessageService = {
  /**
   * Retrieve all alert messages that should be displayed in the app.
   */
  async getAlertMessages(): Promise<AlertMessage[]> {
    const response = await apiClient.getPaginated<AlertMessage>(ALERT_MESSAGES_ENDPOINT, {_page: 0, _size: 100});
    return response.content;
  },

  /**
   * Create a new alert message.
   */
  async createAlertMessage(data: UpsertAlertMessageRequest): Promise<AlertMessage> {
    return await apiClient.post<AlertMessage>(ALERT_MESSAGES_ENDPOINT, data);
  },

  /**
   * Update an existing alert message by ID.
   */
  async updateAlertMessage(id: string, data: UpsertAlertMessageRequest): Promise<AlertMessage> {
    return await apiClient.update<UpsertAlertMessageRequest, AlertMessage>(ALERT_MESSAGES_ENDPOINT, id, data);
  },

  /**
   * Delete an alert message by ID.
   */
  async deleteAlertMessage(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.deleteById(ALERT_MESSAGES_ENDPOINT, id);
  },
};
